import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { User } from 'types';
type userMenu = {
  id: string;
  menu: string;
  isPermission: boolean;
}
export interface GetUserListResponse extends User {
  "Menu": userMenu[]
}
interface BaseResponse<T> {
  rs: number;
  res?: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}

export interface UserListParams extends PaginatedRequestParams {
  full_user_name?: string;
  phone_number?: string;
  roles?: string[];
  company_id?: string;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}
export type CreateMasterDTO = {
  flag: string;
  title?: string | null;
  description?: string;
  type: number;
  isActive: boolean;
};

export type UpdateUserRoleDTO = {
  user_id: string | undefined;
  MenuIds: string[];
}

export type UpdateUserDTO = {
  userId: string;
  email?: string | null;
  name?: string;
  password?: string;
  phoneNumber?: string;
  isActive?: boolean;
  roleType?: number;
};




export type UpdateStatusUnItemDTO = {
  EntryId: string;
  IsApproved?: number;
  UnloadId: string;

};

export type SupplierResponse = BaseResponse<PaginatedResponse<User>>;
export const UpLoadingApiService = () => {
  const getUpLoading = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/UnloadingAdminList`,
      params,
    });

    return response.data;
  };

  const ApporveReject = async (payload: any) => {
    const response = await apiClient<BaseResponse<any>>({
      endpoint: '/AdminWeighbridge/ApproveOrRejecteForUnloading',
      method: 'POST',
      data: payload,
      config: {
        skipAuthRefresh: true,
      },
    });


    return response.data;
  };

  // AdminWeighbridge/ApproveOrRejecteForUnloading
  return {
    getUpLoading,
    ApporveReject
  };
};
